var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.$route.meta.scanExpectations && _vm.q !== '')?_c('div',{staticClass:"scanner"},[_vm._v(_vm._s(_vm.q))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }